import type { SearchTierConfig } from "@gencow/core";

export const DEFAULT_SEARCH_TIER_CONFIG: SearchTierConfig = {
  plan: "free",
  engine: "tsvector",
  hybridSearch: false,
  locale: "english",
  extensions: {
    vector: true,
    pgroonga: false,
  },
};

function sanitizePlan(value: unknown): SearchTierConfig["plan"] {
  return value === "pro" || value === "scale" ? value : "free";
}

function sanitizeEngine(value: unknown): SearchTierConfig["engine"] {
  return value === "pgroonga" ? "pgroonga" : "tsvector";
}

function sanitizeLocale(value: unknown): SearchTierConfig["locale"] {
  return value === "multilingual" ? "multilingual" : "english";
}

function cloneDefault(): SearchTierConfig {
  return {
    ...DEFAULT_SEARCH_TIER_CONFIG,
    extensions: { ...DEFAULT_SEARCH_TIER_CONFIG.extensions },
  };
}

export function parseSearchTierConfig(tierConfigEnv?: string): SearchTierConfig {
  if (!tierConfigEnv) {
    return cloneDefault();
  }

  try {
    const parsed = JSON.parse(tierConfigEnv) as Partial<SearchTierConfig> | null;
    if (!parsed || typeof parsed !== "object") {
      return cloneDefault();
    }

    return {
      plan: sanitizePlan(parsed.plan),
      engine: sanitizeEngine(parsed.engine),
      hybridSearch: parsed.hybridSearch === true,
      locale: sanitizeLocale(parsed.locale),
      extensions: {
        vector: parsed.extensions?.vector !== false,
        pgroonga: parsed.extensions?.pgroonga === true,
      },
      ...(typeof parsed.degradedReason === "string" && parsed.degradedReason.trim()
        ? { degradedReason: parsed.degradedReason.trim() }
        : {}),
    };
  } catch {
    return cloneDefault();
  }
}
